import authHeader from 'srcReact/helpers/auth-header'
import axios from 'axios'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const messengerService = {
  searchMember,
  createConversation,
  createConversationFromLink,
  renameConversation,
  openConversation,
  openConversationFromNotification,
  addMembersToConversation,
  removeMembersFromConversation,
  getConversations,
  searchConversations,
  deleteConversation,
  leaveConversation,
  resumeConversation,
  muteConversation,
  unmuteConversation,
  hideConversation,
  unHideConversation,
  undeleteConversation,
  postMessage,
  updateMessage,
  deleteMessage,
  setAdmin,
  getConversationUpdates,
  filesCreation,
  // deleteFilesFromMessage,
  addReactionToMessage,
  deleteReactionFromMessage,
  getRealTimeUpdate,
  getConversationsList,
  getConversationsSearch,
  getConversationsCheckUpdates,
  getConversationOpen,
  openConversationFromNotificationLink,
  createConversationFromMailLink,
  saveDraftMessage,
  locateMessageInConversation,
  createBackgroundTagMsgr
}

let cancel

function searchMember(search, organizationId, offset, quantity) {
  if (cancel) {
    cancel()
  }

  let params = search?.length > 0 ? `&search=${search}` : ''
  params += offset ? `&offset=${offset}` : ''
  params += quantity ? `&quantity=${quantity}` : ''

  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }

  return doRequestAxios(`/v2/messenger/members?organization_id=${organizationId}${params}`, requestOptions)
}
function createConversation(organizationId, userIds) {
  const data = { organization_id: organizationId, user_ids: userIds }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: data
  }
//   return doRequestAxios(`/v2/messenger/conversation/creation`, requestOptions)
  return doRequestAxios(`/messenger/conversation/create`, requestOptions)
}

function createConversationFromLink(key1, key2) {
  const data = { key1, key2 }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: data
  }

//   return doRequestAxios(`/v2/messenger/conversation/create-from-link`, requestOptions)
  return doRequestAxios(`/messenger/conversation/create-from-link`, requestOptions)
}

function renameConversation(conversationId, name) {
  const data = { conversation_id: conversationId, name: name }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: data
  }

//   return doRequestAxios(`/v2/messenger/conversation/rename`, requestOptions)
  return doRequestAxios(`/messenger/conversation/rename`, requestOptions)
}

function openConversation(conversationId, offset, quantity) {
  let params = `?conversation_id=${conversationId}`
  params += offset ? `&content_offset=${offset}` : ''
  params += quantity ? `&content_quantity=${quantity}` : ''
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
//   return doRequestAxios(`/v2/messenger/conversation/open${params}`, requestOptions)
  return doRequestAxios(`/messenger/conversation/open${params}`, requestOptions)
}

function openConversationFromNotification(key) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
//   return doRequestAxios(`/v2/messenger/conversation/open-from-link?key=${key}`, requestOptions)
  return doRequestAxios(`/messenger/conversation/open-from-link?key=${key}`, requestOptions)
}

function getConversations(organizationId, openMostRecentConversation, offset, quantity) {
  let params = `?organization_id=${organizationId}`
  params += offset ? `&offset=${offset}` : ''
  params += quantity ? `&quantity=${quantity}` : ''
  params += openMostRecentConversation === 0 ? `&with_open_most_recent_conversation=${openMostRecentConversation}` : ''

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/messenger/conversations/list${params}`, requestOptions)
}

function searchConversations(organizationId, search, offset, quantity, type) {
  if (cancel) {
    cancel()
  }
  let params = `?organization_id=${organizationId}`
  params += `&search=${search}`
  params += offset ? `&content_offset=${offset}` : ''
  params += quantity ? `&content_quantity=${quantity}` : ''
  params += type ? `&type=${type}` : ''

  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }
  return doRequestAxios(`/v2/messenger/conversations/search${params}`, requestOptions)
}

function getConversationUpdates(organizationId, workplaceId, conversationId, openConversationId, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
//   return doRequestAxios(`/v2/messenger/conversations/check-updates?organization_id=${organizationId}`, requestOptions)
  return doRequestAxios(`/user/conversations/updates?organization_id=${organizationId}`, requestOptions)
}

function getRealTimeUpdate(organization_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id }
  }

//   return doRequestAxios(`/v2/messenger/conversations/check-updates`, requestOptions)
  return doRequestAxios(`/user/conversations/updates`, requestOptions)
}

function addMembersToConversation(conversationId, userIds) {
  const data = { conversation_id: conversationId, user_ids: userIds }

  const requestOptions = {
//     method: 'PUT',
    method: 'POST',
    headers: authHeader(),
    data: data
  }

//   return doRequestAxios(`/v2/messenger/conversation/members/add`, requestOptions)
  return doRequestAxios(`/messenger/member/add`, requestOptions)
}

function removeMembersFromConversation(conversationId, userIds) {
  const data = { conversation_id: conversationId, user_ids: userIds }

  const requestOptions = {
//     method: 'PUT',
    method: 'DELETE',
    headers: authHeader(),
    data: data
  }
//   return doRequestAxios(`/v2/messenger/conversation/members/remove`, requestOptions)
  return doRequestAxios(`/messenger/member/remove`, requestOptions)
}

function deleteConversation(conversationId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    params: { conversation_id: conversationId }
  }
//   return doRequestAxios(`/v2/messenger/conversation/delete`, requestOptions)
  return doRequestAxios(`/messenger/conversation/delete`, requestOptions)
}

function leaveConversation(conversationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { conversation_id: conversationId }
  }
//   return doRequestAxios(`/v2/messenger/conversation/leave`, requestOptions)
  return doRequestAxios(`/messenger/conversation/leave`, requestOptions)
}

function resumeConversation(conversationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { conversation_id: conversationId }
  }
//   return doRequestAxios(`/v2/messenger/conversation/resume`, requestOptions)
  return doRequestAxios(`/messenger/conversation/resume`, requestOptions)
}

function muteConversation(conversationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { conversation_id: conversationId }
  }
//   return doRequestAxios(`/v2/messenger/conversation/mute`, requestOptions)
  return doRequestAxios(`/messenger/conversation/mute`, requestOptions)
}

function unmuteConversation(conversationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { conversation_id: conversationId }
  }
//   return doRequestAxios(`/v2/messenger/conversation/unmute`, requestOptions)
  return doRequestAxios(`/messenger/conversation/unmute`, requestOptions)
}

function hideConversation(conversationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { conversation_id: conversationId }
  }
//   return doRequestAxios(`/v2/messenger/conversation/hide`, requestOptions)
  return doRequestAxios(`/messenger/conversation/hide`, requestOptions)
}

function unHideConversation(conversationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { conversation_id: conversationId }
  }
//   return doRequestAxios(`/v2/messenger/conversation/show`, requestOptions)
  return doRequestAxios(`/messenger/conversation/show`, requestOptions)
}

function undeleteConversation(conversationId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    params: { conversation_id: conversationId }
  }
//   return doRequestAxios(`/v2/messenger/conversation/undelete`, requestOptions)
  return doRequestAxios(`/messenger/conversation/undelete`, requestOptions)
}

function postMessage(conversationId, message, originMessageId, fileIds, taggedUserIds, containedLinks) {
  const formData = new FormData()
  if (message) {
    formData.append('message', message)
  }
  if (originMessageId) {
    formData.append('origin_message_id', originMessageId)
  }
  if (fileIds) {
    formData.append('file_ids', fileIds)
  }
  if (taggedUserIds) {
    formData.append('tagged_user_ids', taggedUserIds)
  }
  if (containedLinks) {
    formData.append('contained_links', containedLinks)
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(1, ''),
    params: formData
  }

//   return doRequestAxios(`/v2/messenger/conversation/message/add?conversation_id=${conversationId}`, requestOptions)
  return doRequestAxios(`/messenger/message/add?conversation_id=${conversationId}`, requestOptions)
}

function updateMessage(messageId, message, taggedUserIds, containedLinks, offset, quantity) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: { message: message, tagged_user_ids: taggedUserIds, contained_links: containedLinks }
  }
//   return doRequestAxios(`/v2/messenger/conversation/message/update?message_id=${messageId}`, requestOptions)
  return doRequestAxios(`/messenger/message/update?message_id=${messageId}`, requestOptions)
}
function deleteMessage(messageId, offset, quantity) {
  let params = offset ? `&content_offset=${offset}` : ''
  params += quantity ? `&content_quantity=${quantity}` : ''

  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
//   return doRequestAxios(`/v2/messenger/conversation/message/delete?message_id=${messageId}${params}`, requestOptions)
  return doRequestAxios(`/messenger/message/delete?message_id=${messageId}${params}`, requestOptions)
}

// function deleteFilesFromMessage(messageId, fileIds) {
//   const requestOptions = {
//     method: 'DELETE',
//     headers: authHeader(),
//     params: { message_id: messageId, file_ids: fileIds }
//   }
//   return doRequestAxios(`/v2/messenger/conversation/message/delete-file`, requestOptions)
// }

function setAdmin(conversationId, userId, isAdmin) {
  const data = { conversation_id: conversationId, user_id: userId, is_admin: isAdmin }

  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: data
  }
//   return doRequestAxios(`/v2/messenger/conversation/update-admin-role`, requestOptions)
  return doRequestAxios(`/messenger/conversation/admin-role`, requestOptions)
}
function addReactionToMessage(messageId, unicode) {
  const data = { message_id: messageId, unified_unicode: unicode }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: data
  }
//   return doRequestAxios(`/v2/messenger/conversation/reaction/add`, requestOptions)
  return doRequestAxios(`/messenger/reaction/add`, requestOptions)
}
function deleteReactionFromMessage(reactionId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
//   return doRequestAxios(`/v2/messenger/conversation/reaction/delete?reaction_id=${reactionId}`, requestOptions)
  return doRequestAxios(`/messenger/reaction/delete?reaction_id=${reactionId}`, requestOptions)
}

function filesCreation(pictures, params) {
  const formData = new FormData()
  for (let i = 0; i < pictures.length; i++) {
    formData.append(`file_${i + 1}`, pictures[i])
  }
  formData.append('files_count', pictures.length)

  const is_logged = params.is_logged || 0

  const requestOptions = {
    method: 'POST',
    headers: authHeader(1, ''),
    params: formData
  }

  return doRequestAxios(
    `/v2/files/creation/${is_logged}?type=${params.type}&organization_id=${params.organization_id}`,
    requestOptions
  )
}

function getConversationsList(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params
  }

  return doRequestAxios(`/v2/messenger/conversations/list`, requestOptions)
}

function getConversationsCheckUpdates(organization_id, content_offset, content_quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id, content_offset, content_quantity }
  }
//   return doRequestAxios(`/v2/messenger/conversations/check-updates`, requestOptions)
  return doRequestAxios(`/user/conversations/updates`, requestOptions)
}

function getConversationsSearch(organization_id, conversations_type, search, type) {
  if (cancel !== undefined) {
    cancel()
  }

  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c)),
    params: { organization_id, conversations_type, search, type }
  }

  return doRequestAxios(`/v2/messenger/conversations/search`, requestOptions)
}

function getConversationOpen(conversation_id, content_offset, content_quantity) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { conversation_id, content_offset, content_quantity }
  }
//   return doRequestAxios(`/v2/messenger/conversation/open`, requestOptions)
  return doRequestAxios(`/messenger/conversation/open`, requestOptions)
}

function openConversationFromNotificationLink(key) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { key }
  }

//   return doRequestAxios(`/v2/messenger/conversation/open-from-link`, requestOptions)
  return doRequestAxios(`/messenger/conversation/open-from-link`, requestOptions)
}

function createConversationFromMailLink(key1, key2) {
  const requestOptions = {
//     method: 'PUT',
    method: 'POST',
    headers: authHeader(),
    params: { key1, key2 }
  }
//   return doRequestAxios(`/v2/messenger/conversation/create-from-link`, requestOptions)
  return doRequestAxios(`/messenger/conversation/create-from-link`, requestOptions)
}

function saveDraftMessage(conversation_id, origin_message_id, message, file_ids) {
  if (cancel !== undefined) {
    cancel()
  }

  let payload = new FormData()
  if (conversation_id) {
    payload.append('conversation_id', conversation_id)
  }
  // if (origin_message_id) {
  //   payload.append('origin_message_id', origin_message_id)
  // }
  if (message) {
    payload.append('message', message)
  }
  if (file_ids) {
    payload.append('file_ids', file_ids)
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c)),
    params: payload
  }
//   return doRequestAxios(`/v2/messenger/conversation/message/add-draft`, requestOptions)
  return doRequestAxios(`/messenger/draft/add`, requestOptions)
}

function locateMessageInConversation(conversation_id, message_id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { conversation_id, message_id }
  }
//   return doRequestAxios(`/v2/messenger/conversation/locateMessage`, requestOptions)
  return doRequestAxios(`/messenger/message/locate`, requestOptions)
}

function createBackgroundTagMsgr(
  conversation_id,
  images_count,
  documents_count,
  origin_message_id,
  message,
  tagged_user_ids,
  tagged_group_ids,
  tagged_mixr_ids,
  contained_links
) {
  const params = {
    conversation_id,
    images_count,
    documents_count,
    message,
    tagged_user_ids,
    tagged_group_ids,
    tagged_mixr_ids,
    contained_links
  }
  if (origin_message_id > 0) {
    params.origin_message_id = origin_message_id
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: params
  }
//   return doRequestAxios(`/v2/messenger/conversation/message/background-tag/create`, requestOptions)
  return doRequestAxios(`/messenger/background-tag/create`, requestOptions)
}
